import { Button, TableCellLayout } from '@fluentui/react-components'
import { Person24Regular } from '@fluentui/react-icons'
import { RestSchemas } from '@/contexts/QueryProvider'
import { useSearchParams } from 'react-router-dom'

type MessagesSubscriptionsOrganisationSummary = RestSchemas['Messages.Subscriptions.OrganisationSummary']

export function UsersCellContent({ item }: { item: MessagesSubscriptionsOrganisationSummary }) {
  const [searchParams, setSearchParams] = useSearchParams()
  return (
    <TableCellLayout>
      {item.users.toString()}
      {item.usersFrozen !== 0 && <> (+{item.usersFrozen.toString()} active)</>}

      <Button
        appearance="subtle"
        icon={<Person24Regular />}
        onClick={() => {
          searchParams.set('tab', 'users')
          searchParams.set('orgId', item.id.toString())
          searchParams.set('orgName', item.name)
          setSearchParams(searchParams)
        }}
      />
    </TableCellLayout>
  )
}
